import { PieceAction, UpdatePiecesRequest } from '@apiContract';

type ExplicitlyHandledProps = 'pieces' | 'action' | 'isForce' | 'shouldNotify';

type AdditionalData = Partial<Omit<UpdatePiecesRequest, ExplicitlyHandledProps>>;

interface BuildRequestDataParams {
  mailpieces: Array<{ id: number }>;
  action: PieceAction;
  isForce?: boolean;
  shouldNotify?: boolean;
  additionalData?: AdditionalData;
}

export const buildUpdatePiecesRequest = ({
  mailpieces,
  action,
  isForce,
  shouldNotify,
  additionalData = {},
}: BuildRequestDataParams): UpdatePiecesRequest => {
  const requestData: UpdatePiecesRequest = {
    pieces: mailpieces.map((piece) => ({ id: Number(piece.id) })),
    action,
    isForce,
    ...(isForce && shouldNotify !== undefined && { shouldNotify }),
    ...additionalData,
  };

  return requestData;
};
